var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRobot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.25 19.65q-2.594 0-4.422-1.755T2 13.65t1.828-4.245T8.25 7.65h7.5q2.594 0 4.422 1.755T22 13.65t-1.828 4.245-4.422 1.755zm0-1.8h7.5q1.822 0 3.099-1.223 1.276-1.223 1.276-2.97t-1.276-2.977-3.099-1.23h-7.5q-1.822 0-3.099 1.223-1.275 1.222-1.276 2.97 0 1.747 1.276 2.977t3.099 1.23m.005-3.3q.402 0 .667-.26a.87.87 0 0 0 .265-.645q0-.385-.27-.64a.94.94 0 0 0-.672-.255.91.91 0 0 0-.667.26.87.87 0 0 0-.266.645q0 .385.272.64.27.255.671.255m7.5 0q.402 0 .667-.26a.87.87 0 0 0 .265-.645q0-.385-.27-.64a.94.94 0 0 0-.673-.255.91.91 0 0 0-.666.26.87.87 0 0 0-.265.645q0 .385.27.64.271.255.672.255M16.467 5.71a.95.95 0 0 1-.711.29.98.98 0 0 1-.717-.283.95.95 0 0 1-.289-.711q0-.428.283-.717A.95.95 0 0 1 15.744 4q.428 0 .717.283.29.284.289.711a.98.98 0 0 1-.283.717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.25 5.65h1v3h-1zM8.917 5.71a.95.95 0 0 1-.711.29.98.98 0 0 1-.717-.283.95.95 0 0 1-.289-.711q0-.428.283-.717A.95.95 0 0 1 8.194 4q.428 0 .717.283.29.284.289.711a.98.98 0 0 1-.283.717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.7 5.65h1v3h-1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRobot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/robot.698b25f1.svg";